export type Euler = { x: number; y: number; z: number };

function getIframeWindow(): any | null {
  // @ts-ignore
  const containerRef = window.containerRef;
  return containerRef?.current?.contentWindow || null;
}

export function getSelectedEntity(): any | null {
  try {
    const win: any = getIframeWindow();
    if (!win || !win.RoutingScriptMdel) return null;
    const root = win.RoutingScriptMdel.getRootEntity?.();
    const sceneController = root?.script?.sceneController;
    const selected = sceneController?.selectedEntity;
    return selected || null;
  } catch {
    return null;
  }
}

export function readSelectedRotation(): Euler | null {
  try {
    const entity = getSelectedEntity();
    const e = entity?.getLocalEulerAngles?.();
    if (!e) return null;
    return { x: e.x, y: e.y, z: e.z };
  } catch {
    return null;
  }
}

export function setRotation(rot: Euler): boolean {
  try {
    const entity = getSelectedEntity();
    if (!entity?.setLocalEulerAngles) return false;
    entity.setLocalEulerAngles(rot.x, rot.y, rot.z);
    return true;
  } catch {
    return false;
  }
}

